<div class="field-label" [ngClass]="{'text-center': !withText && !isGroup}"
  [matTooltipPosition]="'below'"
  [matTooltip]="cellValue" [matTooltipDisabled]="withText">
  @if (pictogram) {
    <img class='pictogram' [src]="appConfig.PICTOGRAM_FOLDER_PATH + pictogram" [alt]="cellValue">
  }
  @if (withText) {
    <span>&nbsp; {{ cellValue }}</span>
  }
</div>
